import React from 'react';
import { Box } from '../box';
import { styled } from '../../theme/styled';
import { SxProps } from '../../theme';

export interface ProgressBarProps {
  value: number;
  sx?: SxProps;
}

const Root = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 4,
  backgroundColor: theme.palette['gray middle'],
  position: 'relative',
  overflow: 'hidden',
}));

const Bar = styled('span')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  transformOrigin: 'left center',
  transition: 'transform 0.4s linear 0s',
  backgroundColor: theme.palette['brand pink'],
}));

export const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  const value = props.value * 100;
  return (
    <Root aria-valuemax="100" aria-valuemin="0" aria-valuenow={value} role="progressbar" sx={props.sx}>
      <Bar style={{ transform: `translateX(-${100 - value}%)` }} />
    </Root>
  );
};
